import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment as ENV } from '@environment/environment';

import { LanguageV3Service } from '@services/language-v3.service';

import { Country, CountryResponse, CountryWithCode, Department, DepartmentResponse, District, DistrictResponse, State, StateResponse } from '@interfaces/i-country';
import { ResponseSoaApi } from '@app/core/models/interfaces/i-cancel-subscription';

@Injectable({
  providedIn: 'root',
})
export class CountryV3Service  {

  private API = `${ENV.webApi}v2/country`;
  private soaApi = `${ENV.soaApiBaseUrl}`;

  constructor(private http: HttpClient, private languageService: LanguageV3Service) {}

  public getAllCountries(): Observable<Country[]> {
    const loc = this.languageService.locale;
    if (loc === 'es-ES') {
      return this.http.get<Country[]>('/assets/mock/countries-es.json');
    } else {
      return this.http.get<Country[]>('/assets/mock/countries-en.json');
    }
  }

  public getAllCountriesV2(): Observable<CountryResponse> {
    return this.http.get<CountryResponse>(`${this.soaApi}Country/getCountries`);
  }

  public getStatesV2(countryId: string): Observable<StateResponse> {
    return this.http.get<StateResponse>(`${this.soaApi}Country/getStatesByCountry/${countryId}`)
  }

  public getDepartmentsV2(stateId: string): Observable<DepartmentResponse> {
    return this.http.get<DepartmentResponse>(`${this.soaApi}Country/getDeparments/${stateId}`);
  }

  public getDistrictsV2(departmentId: string): Observable<DistrictResponse> {
    return this.http.get<DistrictResponse>(`${this.soaApi}Country/getDistricts/${departmentId}`);
  }

  getCountriesLite(): Observable<Country[]> {
    return this.http.get<Country[]>(`${this.API}/list/lite`);
  }

  public getCountriesWithCode(): Observable<CountryWithCode[]> {
    return this.http.get<CountryWithCode[]>(`${this.API}/countryWithCodes`);
  }

  public getStates(countryCode: string = 'us', countryId: string= '9b475007-d87f-4e06-8cb8-430b69242bc7'): Observable<State[]> {
    return this.http.get<State[]>(`${this.API}/${countryCode}/states?orderBy=nameenlgish`);
  }

  public getDepartments(stateCode: string = 'us', stateId: string ='694ab590-e465-4a0d-b1da-05b8df29a43a'): Observable<Department[]> {
    return this.http.get<Department[]>(`${this.API}/${stateCode}/departments?orderBy=nameenlgish`);
  }

  public getDistricts(departmentCode: string): Observable<District[]> {
    return this.http.get<District[]>(`${this.API}/${departmentCode}/districts?orderBy=nameenlgish`);
  }

  public getCountryStateCommunity(countryId: string): Observable<ResponseSoaApi> {
    const url = `${this.soaApi}Country/getStatesByCountry/${countryId}`;
    return this.http.get<ResponseSoaApi>(url);
  }

  getDialCodeByCountryId(countryId: string): Observable<ResponseSoaApi> {
    const url = `${this.soaApi}Country/getDialCode/${countryId}`;
    return this.http.get<ResponseSoaApi>(url);
  }

  getDialCode(): Observable<ResponseSoaApi> {
    const url = `${this.soaApi}Country/dialcodes/`;
    return this.http.get<ResponseSoaApi>(url);
  }

}
